<div class="right-side p-5">
  <h2>Repository Dashboard</h2>
  <div class="section">
    <form [formGroup]="form1">


      <div class="row">
        <div class="text-end">
          <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">
            <i class="bi bi-file-earmark-excel"></i> Export To Excel
          </button>
        </div>

        <div class="col-lg-7 col-sm-12">
          <div class="search-container">
            <mat-form-field class="search-input w-75" appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput formControlName="searchControl" />
            </mat-form-field>
            <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(form1.get('searchControl')?.value ?? '')" id="btnSearch">
              <i class="bi bi-search fs-4"></i>
            </button>
          </div>
          <div *ngIf="form1.get('searchControl')?.invalid && (form1.get('searchControl')?.touched)">
            <small *ngIf="form1.get('searchControl')?.errors?.['pattern']" class="text-danger">
              Invalid search term.
            </small>
          </div>
        </div>
        </div>
        <!--<div class="table-responsive">
      <table class="table table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th>Sr.No</th>

            <th class="text-center">IAUserName</th>
            <th class="text-center">Interest Name</th>
            <th class="text-center">Intervention Name</th>

            <th class="text-center">Created Date</th>
            <th class="text-center">Document Name</th>
            <th class="text-center">Download</th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let gr of RepositoryDetailsData ; let i = index ">
            <td>{{ gr.rowNum }}</td>
            <td class="text-center">{{ gr.iaUserName }}</td>
            <td class="text-center">{{ gr.interestName }}</td>
            <td class="text-center">{{ gr.interventionName }}</td>

            <td class="text-center">{{ gr.createdDate }}</td>

            <td class="text-center">{{ gr.documentName }}</td>

            <td class="text-center">
              <a *ngIf="gr.documentPath"
                 (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()" style="cursor: pointer" class="btn btn-warning btn-sm">

                <i class="bi bi-download"></i> Download
              </a>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <mat-paginator #paginator
                   class="demo-paginator"
                   (page)="onPageChange($event)"
                   [length]="length"
                   [pageSize]="pageSize"
                   [disabled]="disabled"
                   [showFirstLastButtons]="showFirstLastButtons"
                   [pageSizeOptions]="pageSizeOptions"
                   [hidePageSize]="hidePageSize"
                   [pageIndex]="pageIndex"
                   aria-label="Select page">
    </mat-paginator>-->


        <div class="table-responsive">
          <table mat-table [dataSource]="RepositoryDetailsData" class="table table-striped table-bordered table-hover mat-elevation-z8" matSort matSortActive="CreatedDate" matSortDirection="asc" matSortDisableClear>

            <!-- Sr. No Column -->
            <ng-container matColumnDef="SrNo">
              <th mat-header-cell *matHeaderCellDef> Sr. No. </th>
              <td mat-cell *matCellDef="let gr"> {{gr.rowNum}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let gr"> {{gr.iaUserName}} </td>
            </ng-container>

            <!-- Intervention Column -->
            <ng-container matColumnDef="Intervention">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Intervention </th>
              <td mat-cell *matCellDef="let gr"> {{gr.interventionName}} </td>
            </ng-container>

            <!-- Interest Column -->
            <ng-container matColumnDef="Interest">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Interest </th>
              <td mat-cell *matCellDef="let gr"> {{gr.interestName}} </td>
            </ng-container>

            <!-- Created Date Column -->
            <ng-container matColumnDef="CreatedDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
              <td mat-cell *matCellDef="let gr"> {{gr.createdDate}} </td>
            </ng-container>

            <!-- Document Name Column -->
            <ng-container matColumnDef="DocumentName">
              <th mat-header-cell *matHeaderCellDef> Document Name </th>
              <td mat-cell *matCellDef="let gr"> {{gr.documentName}} </td>
            </ng-container>

            <!-- Download Column -->
            <ng-container matColumnDef="Download">
              <th mat-header-cell *matHeaderCellDef style="width:150px;"> Download </th>
              <td mat-cell *matCellDef="let gr">
                <a *ngIf="gr.documentPath"
                   (click)="onDownload(gr.documentPath, gr.documentName); $event.preventDefault()"
                   style="cursor: pointer"
                   class="btn btn-warning btn-sm">
                  <i class="bi bi-download"></i> Download
                </a>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <!-- Data Row -->
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- No Data Row -->
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="7">No data matching the filter</td>
            </tr>
          </table>
        </div>

        <!-- Paginator -->
        <mat-paginator #paginator
                       class="demo-paginator"
                       (page)="onPageChange($event)"
                       [length]="length"
                       [pageSize]="pageSize"
                       [showFirstLastButtons]="showFirstLastButtons"
                       [pageSizeOptions]="pageSizeOptions"
                       [hidePageSize]="hidePageSize"
                       [pageIndex]="pageIndex"
                       aria-label="Select page">
        </mat-paginator>

    </form>
  </div>
</div>




